import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { convertFontSize } from './Util';
import { ScreenContext } from './ScreenProvider';
// import { ResponsiveText } from './ResponsiveUiComponent';
// import { convertFontSize } from './Util';

interface NumberCountAnimationProps {
  value: number;
  duration?: number; // 애니메이션 지속 시간 (밀리초)
}

const CountContainer = styled.span<{$screen: string}>`
  font-size: clamp(0.9375rem, 0.0318rem + 4.1401vw, 5rem);
  font-weight: bold;
  color: #2EA090;

  @media (max-width: 768px) {
    font-size: ${(props) => convertFontSize(40, 60, props.$screen)};
  }
`;

const CountNumber: React.FC<NumberCountAnimationProps> = ({ value, duration = 1500 }) => {
  const screen = useContext(ScreenContext).style;
  const [count, setCount] = useState<number>(0);
  const stepTime = 16; // 예시로 16ms (약 60FPS)
  const totalSteps = Math.ceil(duration / stepTime);
  const stepAmount = value / totalSteps;

  const [isCount, setIsCount] = useState<boolean>(false);

  const options:IntersectionObserverInit = {
    root: null,
    threshold: 0
  }
  const callback:IntersectionObserverCallback = (entries:IntersectionObserverEntry[],observer) => {
    // console.log(entries);
    entries.forEach((entry) => {
      const {
        isIntersecting, 
      } = entry;
      // pageYOffset 문서가 수직으로 얼마나 스크롤 됐는지 픽셀 단위로 반환한다.
      // const scrollTop = document.getElementById("main").scrollTop;

      // 이벤트가 발생된 target의 height
      // const {height} = boundingClientRect;

      // 관찰 요소와 교차될때마다 index를 계산하여 viewIndex의 값을 바꿔준다.
      if(isIntersecting) {
        // const index = Math.round(scrollTop / height);
        setIsCount(true);
      } else {
        setIsCount(false);
      }
    });
  };

  useEffect(() => {
    // console.log(isCount);
  }, [isCount]);
  
  const io = new IntersectionObserver(callback,options);

  useEffect(() => {
    const el = document.getElementById("count-box");
    io.observe(el);

    return () => {
      io.unobserve(el);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {
    if(!isCount) return;
    let currentCount = 0;
    let currentStep = 0;

    const timer = setInterval(() => {
      currentCount += stepAmount;
      currentStep++;

      if (currentStep >= totalSteps) {
        clearInterval(timer);
        currentCount = value; // 확실한 완료 값으로 설정
      }

      setCount(Math.round(currentCount));
    }, stepTime);
    
    return () => {
      clearInterval(timer);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCount]);

  return (
    <CountContainer $screen={screen}>{count}</CountContainer>
  );
};

export default CountNumber;